// extracted by mini-css-extract-plugin
module.exports = {"type":"FeatureTest_type_2XEVt","table":"FeatureTest_table_29vW3"};